module.exports = __webpack_public_path__ + "img/zuopin5.8a9f76f0.jpg";